import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(Router)

 let router= new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import( './views/index')
    },
    {
      path: '/list/:portId',
      name: 'list',
      component: () => import( './views/list')
    },
    {
      path: '/article/:articleId',
      name: 'article',
      component: () => import( './views/article')
    },
    {
      path: '/search/:findInfo',
      name: 'search',
      component: () => import( './views/search')
    },
    {
      path: '/search',
      name: 'search2',
      component: () => import( './views/search')
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  NProgress.start();
    next()
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

export default router